(()=>{
  const initRail=rail=>{
    if(!rail||rail.dataset.akInventoryChevronsReady==='true')return;
    rail.dataset.akInventoryChevronsReady='true';

    const track=rail.querySelector('.ak-inventory-track');
    if(!track)return;

    const heading=rail.querySelector('.ak-inventory-rail__head h3')?.textContent.trim()||'jerky';

    const makeArrow=(direction,label)=>{
      const button=document.createElement('button');
      button.type='button';
      button.className=`ak-inventory-rail-chevron ak-inventory-rail-chevron--${direction}`;
      button.setAttribute('aria-label',`${label} ${heading}`);
      button.innerHTML='<span aria-hidden="true"></span>';
      rail.appendChild(button);
      return button;
    };

    const prev=makeArrow('prev','Previous');
    const next=makeArrow('next','Next');

    const cards=()=>[...track.querySelectorAll('.ak-inventory-card')];

    const step=()=>{
      const first=cards()[0];
      if(!first)return Math.max(220,track.clientWidth*.72);
      const styles=getComputedStyle(track);
      const gap=parseFloat(styles.columnGap||styles.gap||'12')||12;
      return first.getBoundingClientRect().width+gap;
    };

    const maxScroll=()=>Math.max(0,track.scrollWidth-track.clientWidth);

    const updatePosition=()=>{
      const top=track.offsetTop+(track.clientHeight/2);
      rail.style.setProperty('--ak-rail-arrow-top',`${Math.round(top)}px`);
      const unneeded=maxScroll()<8;
      prev.classList.toggle('is-unneeded',unneeded);
      next.classList.toggle('is-unneeded',unneeded);
    };

    const scrollDirection=direction=>{
      const max=maxScroll();
      if(max<8)return;
      const tolerance=Math.max(8,step()*.12);
      if(direction==='next'){
        if(track.scrollLeft>=max-tolerance){
          track.scrollTo({left:0,behavior:'smooth'});
        }else{
          track.scrollBy({left:step(),behavior:'smooth'});
        }
      }else{
        if(track.scrollLeft<=tolerance){
          track.scrollTo({left:max,behavior:'smooth'});
        }else{
          track.scrollBy({left:-step(),behavior:'smooth'});
        }
      }
    };

    prev.addEventListener('click',event=>{
      event.preventDefault();
      event.stopPropagation();
      scrollDirection('prev');
    });
    next.addEventListener('click',event=>{
      event.preventDefault();
      event.stopPropagation();
      scrollDirection('next');
    });

    updatePosition();
    window.addEventListener('resize',updatePosition,{passive:true});
    if('ResizeObserver' in window)new ResizeObserver(updatePosition).observe(track);
    if('MutationObserver' in window)new MutationObserver(updatePosition).observe(track,{childList:true});
  };

  const initAll=(scope=document)=>scope.querySelectorAll?.('.ak-inventory-rail').forEach(initRail);
  document.addEventListener('DOMContentLoaded',()=>initAll(document));
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
  window.addEventListener('pageshow',()=>initAll(document));
})();
